import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { TipoServicoContext } from '../../context/TipoServicoContext';
import { TipoServicoType, CreateTipoServicoType, UpdateTipoServicoType } from '../../context/hooks/useTipoServico';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateTipoServicoModal } from '../../components/TipoServico/CreateTipoServicoModal';
import { EditTipoServicoModal } from '../../components/TipoServico/EditTipoTerceiroModal';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const TipoServico = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listTipoServico, pageCount, getAllTipoServicoPaged, createTipoServico, updateTipoServico, deleteTipoServico } = useContext(TipoServicoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [selectedTipoServicoId, setSelectedTipoServicoId] = useState(0);
    const [newTipoServico, setNewTipoServico] = useState<CreateTipoServicoType>({
        name: '',
        value: 0,
        empresaId: objUserTk.EmpresaId,
    });
    const [editingTipoServico, setEditingTipoServico] = useState<UpdateTipoServicoType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        type: '',
    });

    useEffect(() => {
        setLoading(true);
        getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar tipos de terceiro:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllTipoServicoPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            });
    };

    const handleEditTipoServico = (tipoServico: TipoServicoType) => {
        setEditingTipoServico(tipoServico);
        setEditModalOpen(true);
    };

    const [confirmDeleteTipoServicoId, setConfirmDeleteTipoServicoId] = useState<number | null>(null);

    const handleDeleteTipoServico = (tipoServicoId: number) => {
        setConfirmDeleteTipoServicoId(tipoServicoId);
    };

    const executeDeleteTipoServico = () => {
        if (confirmDeleteTipoServicoId == null) return;
        deleteTipoServico(confirmDeleteTipoServicoId)
            .then(deletedTipoServico => {
                if (!deletedTipoServico) console.error("Erro ao excluir serviço.");
                getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId);
            })
            .catch(error => console.error("Erro ao excluir serviço:", error));
        setConfirmDeleteTipoServicoId(null);
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Serviços"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {hasPermission(PermissionModule.Terceiros, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar serviço
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Terceiros, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Valor padrão</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoServico.map((tipoServico: TipoServicoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{tipoServico.name}</td>
                                                {/* <td>{tipoServico.value}</td> */}
                                                <td>{tipoServico.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? '-'}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Terceiros, 3) && (
                                                        <Button onClick={() => { handleEditTipoServico(tipoServico); setSelectedTipoServicoId(tipoServico.id); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Terceiros, 4) && (
                                                        <Button onClick={() => handleDeleteTipoServico(tipoServico.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount > 0 ? (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                ) : null}
                                {listTipoServico.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os tipos de serviços.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateTipoServicoModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId)}
            />

            <EditTipoServicoModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                tipoServico={editingTipoServico}
                onUpdated={() => getAllTipoServicoPaged(1, 9, objUserTk.EmpresaId)}
            />

            <ModalConfirm
                openModal={confirmDeleteTipoServicoId !== null}
                closeModal={() => setConfirmDeleteTipoServicoId(null)}
                handleConfirm={executeDeleteTipoServico}
                title="Excluir serviço"
                message="Tem certeza que deseja excluir este serviço? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default TipoServico;